// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__36DVd","actions":"GroupTable_actions__j8B-_","deleteModalFooter":"GroupTable_deleteModalFooter__35D6R"};